import type { FaireProductEntity } from "../../entity_types/product";

export const p_f9haqs7tu2: FaireProductEntity = {
  token: "p_f9haqs7tu2",
  type: "product",
  name: "Bible Story Memory Games Merchandiser",
  brandToken: "b_3811aa80",
  brandName: "Christian Art Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/2ee5e6d49911c887f18fe3e36b74775a24cf709df8058dd3127b21814f8afb36.jpeg",
  galleryImageUrls: [],
  priceDollars: 83.06,
  description:
    "Bible Story Memory Games make an exciting addition to a child's Bible education. This merchandiser holds 12 memory game sets.",
  tags: [],
  msrpDollars: 166.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:32.410Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
